export const getAffiliateLink = (tcgPlayerProductId?: number) => {
	const path = tcgPlayerProductId ? `/product/${String(tcgPlayerProductId)}` : "/";
	return `https://www.tcgplayer.com${path}?utm_campaign=affiliate&utm_source=FyendalsCollection&utm_medium=FyendalsCollection`;
};
